import "../../styles/Latestinsights.css";
import blog1 from "../../assets/images/blog1.png";
import blog2 from "../../assets/images/blog2.png";

import blog3 from "../../assets/images/blog-3.webp";
import blog4 from "../../assets/images/ai-automation.webp";
import blog5 from "../../assets/images/blog-5.webp";
import blog6 from "../../assets/images/blog-6.webp";
import blog7 from "../../assets/images/lead-blog1.webp";


import { Link } from "react-router-dom";

const blogs = [
  {
    id: 1,
    image: blog1,
    title:
      "Low Website Traffic? 10 Proven Ways to Increase Organic Traffic in 30 Days",
  },
  {
    id: 2,
    image: blog2,
    title:
      "Why Your Website is Not Ranking on Google and How to Fix It Fast (2026 Guide)",
  },
  {
    id: 3,
    image: blog3,
    title: "Google SGE Explained: How Search is Changing in 2026 & What to Do",
  },
  {
    id: 4,
    image: blog4,
    title:
      "What is Artificial Intelligence? Complete Guide for Beginners (2026)",
  },
  {
    id: 5,
    image: blog5,
    title:
      "One AI Tool That Can Fully Automate Your Entire Business",
  },
  {
    id: 6,
    image: blog6,
    title: "How AI Can Grow Your Business Faster (Complete Guide 2026)",
  },
  {
    id: 7,
    image: blog7,
    title: "Why 90% of Marketers Fail at Lead Generation in 2026",
  },

];

const BlogSection = () => {
  return (
    <section className="blog-section">
      <div className="blog-container">
        <div className="blog-left">
          <div className="section-badge">Latest Blogs</div>
          <h2>
            Latest Insights & Trends:
            <br /> News & Blogs
          </h2>
          <p className="description">
            Stay updated with the latest marketing insights, industry trends,
            and expert strategies. Explore practical tips, in-depth guides, and
            fresh ideas to grow your brand and strengthen your digital presence.
          </p>

          <Link to="/blog">
            <button className="latest-btn">MORE LATEST BLOG</button>
          </Link>
        </div>

        <div className="blog-right">
          <div className="blog-slider">
            {blogs.map((blog) => (
              <div className="blog-card" key={blog.id}>
                <img src={blog.image} alt={blog.title} />
                <div className="blog-content">
                  <h3>{blog.title}</h3>

                  <Link to="/blog">
                    <button className="read-btn">Read More</button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
